import { CircularProgress, Skeleton, Stack, Typography } from "@mui/material";
import { Service } from "../../../../types/entities";
import React from "react";
import { FormattedMessage } from "react-intl";

const LoadingTranslations = ({ services }: { services: Service[] }) => {
	return (
		<Stack spacing={0.8}>
			<Stack position="relative" alignItems="center" justifyContent="center">
				<Skeleton variant="rounded" width="100%" height={268} />
				<Stack spacing={1} position="absolute" alignItems="center">
					<CircularProgress size={30} />
					<Typography>
						<FormattedMessage
							id="service.generatingTranslations"
							defaultMessage="Generando traducciones con IA..."
						/>
					</Typography>
				</Stack>
			</Stack>
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<Skeleton
					variant="rounded"
					width={18}
					height={18}
					sx={{ marginX: 5 }}
				/>
				<Stack direction="row" spacing={0.5}>
					{services.map((service) => (
						<Skeleton
							key={service.id}
							variant="circular"
							width={8}
							height={8}
						/>
					))}
				</Stack>
				<Skeleton
					variant="rounded"
					width={18}
					height={18}
					sx={{ marginX: 5 }}
				/>
			</Stack>
		</Stack>
	);
};

export default LoadingTranslations;
